import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { fetchMyOperationRequestDetail } from "../operationRequestsApi.js";
import { navigateToCrmOpsDocket } from "../../../Pages/Agent/Crm/navigateToCrmOpsDocket";

const { Text } = Typography;

/**
 * Legacy standalone request detail removed — redirect into CRM docket Ops chat.
 */
export default function AgentOperationRequestDetailPage() {
  const { requestId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const id = String(requestId || "").trim();
      if (!id) {
        navigate("/p/dashboard/drafts?tab=dockets&pane=ops", { replace: true });
        return;
      }
      try {
        const data = await fetchMyOperationRequestDetail(id);
        if (cancelled) return;
        if (!data?.ok || !data?.request) {
          throw new Error(data?.message || "פנייה לא נמצאה");
        }
        await navigateToCrmOpsDocket(navigate, data.request, { replace: true });
      } catch (e) {
        if (cancelled) return;
        setError(String(e?.response?.data?.message || e?.message || e));
        navigate("/p/dashboard/drafts?tab=dockets&pane=ops", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate, requestId]);

  return (
    <div
      style={{
        padding: 48,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
        direction: "rtl",
      }}
    >
      <Spin tip="מעביר לדוקט..." />
      {error ? <Text type="danger">{error}</Text> : null}
    </div>
  );
}
